import i18n from "i18next";
import * as Yup from "yup";

import type { CountryCode } from "@krea/shared/types/common";
import { isValidMobileNumber } from "@krea/shared/utils/isValidMobileNumber";

export const MobilePhoneNumberValidation = (countryCode: CountryCode) => {
  return Yup.string()
    .required(i18n.t("formFields.phoneErrors.required", { ns: "formFields" }))
    .test(
      "phone-validity-libphonenumber",
      i18n.t("formFields.phoneErrors.invalid", { ns: "formFields" }),
      (value) => {
        if (value) {
          return isValidMobileNumber(value, countryCode);
        }
      },
    );
};

export const OptionalMobilePhoneNumberValidation = (
  countryCode: CountryCode,
) => {
  return Yup.string()
    .optional()
    .test(
      "phone-validity-libphonenumber",
      i18n.t("formFields.phoneErrors.invalid", { ns: "formFields" }),
      (value) => {
        if (!value || value.trim() === "") return true;
        return isValidMobileNumber(value, countryCode);
      },
    );
};
